import { render, staticRenderFns } from "./myFeedback.vue?vue&type=template&id=25213770&scoped=true&"
import script from "./myFeedback.vue?vue&type=script&lang=ts&"
export * from "./myFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./myFeedback.vue?vue&type=style&index=0&id=25213770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25213770",
  null
  
)

export default component.exports